import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { setAllApps, setApps } from '../actions/applifecycle.actions';
import { getUser, loginFailure, logoutUser, setUser } from '../actions/auth.actions';
import { setUsers } from '../actions/users.actions';
import { reducers } from '../reducers/reducers';

import { AppGlobalService } from 'src/app/services/app.global.service';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private http = inject(HttpClient);
  private appGlobalService = inject(AppGlobalService);

  getUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getUser),
        map((action: any) => {
          this.store.dispatch(loginFailure({ loginError: null }));
          return this.baseService[action.authApiConstants?.method](action.authApiConstants).subscribe(
            (userInfo: any) => {
              this.appGlobalService.write('isBetaAccessEnabled', userInfo?.betaAccess || false);

              this.appGlobalService.write('raiModeEnabledForUser', userInfo?.raiModeEnabled || false);

              this.store.dispatch(setUser({ userData: userInfo }));
              this.appGlobalService.write('userEmail', userInfo?.email);

              this.store.dispatch(loginFailure({ loginError: null }));
            },
            (error: any) => {
              this.store.dispatch(setUser({ userData: null }));
              this.store.dispatch(loginFailure({ loginError: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  logoutUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logoutUser),
        map((_action: any) => {
          localStorage.setItem('logout', 'true');
          this.http.get(`${window.location.origin}/logout`).subscribe({
            next: (_data: any) => {
              this.redirectToLogin();
            },
            error: (_err) => {
              this.redirectToLogin();
            }
          });
          this.store.dispatch(setApps({ appList: [] }));
          this.store.dispatch(setAllApps({ allAppList: [], totalRecords: 0 }));
          this.store.dispatch(setUsers({ usersData: [], totalRecords: 0 }));
          Object.keys(reducers).map((red: string) => {
            localStorage.removeItem(red);
          });
          localStorage.removeItem('appRole');
          localStorage.removeItem('orgId');
        })
      ),
    {
      dispatch: false
    }
  );

  /**
   * Redirects to the login page on the ROOT path, stripping any Cloud Run
   * version context path (e.g. "/v1/", "/v2/"). Login and logout must always
   * live at the domain root regardless of which version served the app. Uses a
   * hard navigation (replace) so logout fully resets app state.
   */
  private redirectToLogin(): void {
    window.location.replace(`${window.location.origin}/#/login`);
  }
}
